export default "__VITE_ASSET__1904e86d__"